import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { OnlineProduct } from '../interfaces/product';
import { CardPriceService } from '../services/card-price.service';

/// A price as a list shows it, in US dollars.
export interface ShownPrice
{
    Price: number;
    RegularPrice: number;
    Discount: number;
}

/// What a product costs where a list shows it outside a card - the sidebar's product lists, the search suggestions, the
/// wishlist, the compare table, a sold-out product's "in stock now" suggestions - in the
/// visitor's country: the figures its product card and product page show (CardPriceService: what the page opens on there),
/// the listing's own until the answer is in. `product | cardPrice | async`. Pure, so each product
/// of a list asks once however often the list is drawn, and every list on a screen goes in the cards' one request.
@Pipe({ name: 'cardPrice' })
export class CardPricePipe implements PipeTransform
{
    constructor(private cardPrices: CardPriceService) { }

    transform(product: OnlineProduct): Observable<ShownPrice>
    {
        const own: ShownPrice = {
            Price: product ? product.Price : 0,
            RegularPrice: product ? product.RegularPrice : 0,
            Discount: product ? product.Discount : 0,
        };
        if (!product) { return of(own); }

        return this.cardPrices.priceFor(product).pipe(
            map(theirs => theirs ? { Price: theirs.Price, RegularPrice: theirs.RegularPrice, Discount: theirs.Discount } : own),
            startWith(own));
    }
}
